import { render, staticRenderFns } from "./ExhibitionType.vue?vue&type=template&id=1495a7f6&scoped=true&"
import script from "./ExhibitionType.vue?vue&type=script&lang=js&"
export * from "./ExhibitionType.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionType.vue?vue&type=style&index=0&id=1495a7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495a7f6",
  null
  
)

export default component.exports